import { ResourceRef, ResourceStatus, WritableSignal } from '@angular/core';
import { defer, finalize, MonoTypeOperatorFunction, Observable } from 'rxjs';

type ResourceStatusCheckerFn = <T>(resource: ResourceRef<T>) => boolean;

const _resourceStatusChecker = <T>(resource: ResourceRef<T>, status: ResourceStatus | ResourceStatus[]): boolean => {
    const resStatus = resource.status();
    if (Array.isArray(status)) {
        return status.some((v) => resStatus === v);
    } else {
        return resStatus === status;
    }
};

export const resourceSuccess: ResourceStatusCheckerFn = <T>(resource: ResourceRef<T>): boolean => {
    return _resourceStatusChecker(resource, [ResourceStatus.Resolved, ResourceStatus.Local]);
};

export const resourceError: ResourceStatusCheckerFn = <T>(resource: ResourceRef<T>): boolean => {
    return _resourceStatusChecker(resource, ResourceStatus.Error);
};

export const resourceLoading: ResourceStatusCheckerFn = <T>(resource: ResourceRef<T>): boolean => {
    return _resourceStatusChecker(resource, [ResourceStatus.Loading, ResourceStatus.Reloading]);
};

/**
 * Holds `flag` true for the lifetime of the source, so the control that triggered the call shows the
 * wait itself (button `loading`, table `loading`) instead of blocking the page.
 */
export const withBusy = <T>(flag: WritableSignal<boolean>): MonoTypeOperatorFunction<T> => {
    return (source: Observable<T>): Observable<T> =>
        defer(() => {
            flag.set(true);
            return source.pipe(finalize(() => flag.set(false)));
        });
};
